import "core-js/modules/es.array.concat";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import scrollama from 'scrollama';

var DrawLine = /*#__PURE__*/function () {
  function DrawLine(line) {
    _classCallCheck(this, DrawLine);

    this.line = line;
    this.svg = line.querySelector('svg');
    this.path = line.querySelector('path');
    this.pathSize = 0;
    this.scrollListener = scrollama();
    this.request = window.request;
  }

  _createClass(DrawLine, [{
    key: "setPath",
    value: function setPath() {
      this.pathSize = this.path.getTotalLength(); // Make very long dashes (the length of the path itself)

      this.path.style.strokeDasharray = "".concat(this.pathSize, " ").concat(this.pathSize); // Offset the dashes so the it appears hidden entirely

      this.path.style.strokeDashoffset = this.pathSize;
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      var _this = this;

      this.scrollListener.setup({
        step: this.svg,
        offset: 0.3,
        progress: true
      }).onStepProgress(function (response) {
        var render = function render() {
          var scrollPercentage = response.progress; // Length to offset the dashes

          var drawLength = _this.pathSize * scrollPercentage;

          if (window.previousLineAnimated) {
            // Draw in reverse
            _this.path.style.strokeDashoffset = "".concat(_this.pathSize - drawLength); // When complete, remove the dash array, otherwise shape isn't quite sharp
            // Accounts for fuzzy math

            _this.path.style.strokeDasharray = "".concat(_this.pathSize, " ").concat(_this.pathSize);
          }
        };

        _this.request = window.requestAnimationFrame(render);
      }).onStepExit(function (response) {
        window.previousLineAnimated = false;

        var resetLineBoolean = function resetLineBoolean() {
          window.previousLineAnimated = true;

          _this.path.removeEventListener('transitionend', resetLineBoolean, false);
        };

        _this.path.addEventListener('transitionend', resetLineBoolean, false);

        window.cancelAnimationFrame(_this.request);

        if (response.direction === 'up') {
          _this.path.style.strokeDashoffset = _this.pathSize;
        } else if (response.direction === 'down') {
          _this.path.style.strokeDashoffset = '0';
        }
      });
    }
  }, {
    key: "init",
    value: function init() {
      this.setPath();
      this.onScroll();
    }
  }]);

  return DrawLine;
}();

export { DrawLine as default };